import { ReactNode } from 'react'

import { Stack } from '@mui/material'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { TimePicker as MUITimePicker } from '@mui/x-date-pickers/TimePicker'

export interface Props {
  value: Date | null
  onChange: (value: Date | null) => void
  label: ReactNode
  testId?: string
  format: '24' | '12'
}

export function TimePicker(props: Props) {
  const { label, value, onChange, testId, format } = props

  return (
    <Stack direction="column">
      {label}
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <MUITimePicker
          data-testId={testId}
          data-trackId={testId}
          value={value}
          format={format === '24' ? 'HH:mm' : 'hh:mm aa'}
          onChange={onChange}
          timeSteps={{ minutes: 1 }}
          slotProps={{
            field: {
              clearable: true,
            },
            textField: {
              placeholder: 'hh:mm',
              inputProps: {
                readOnly: true,
              },
            },
          }}
        />
      </LocalizationProvider>
    </Stack>
  )
}
